"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.regexp.replace");
var _map = _interopRequireDefault(require("@/assets/map.jpg"));
var _pageBg = _interopRequireDefault(require("@/assets/pageBg.png"));
var _guang = _interopRequireDefault(require("@/assets/guang.png"));
var _top = _interopRequireDefault(require("@/assets/top.png"));
var _echarts = _interopRequireWildcard(require("echarts"));
var echarts = _echarts;
var _china = _interopRequireDefault(require("@/utils/china.json"));
var _scaleScreen = _interopRequireDefault(require("@/components/scale-screen/scale-screen.vue"));
var _export = require("echarts/lib/export");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var scale = {
  width: "1",
  height: "1"
};

// * 设计稿尺寸（px）
var baseWidth = 1920;
var baseHeight = 1080;
// * 需保持的比例（默认1.77778）
var baseProportion = parseFloat((baseWidth / baseHeight).toFixed(5));
var _default = exports.default = {
  name: "Home",
  components: {
    ScaleScreen: _scaleScreen.default
  },
  data: function data() {
    return {
      showLoading: true,
      paymant_data: {
        data: [],
        colors: ["#e062ae", "#fb7293", "#e690d1", "#32c5e9", "#96bfff"],
        unit: "元",
        showValue: true
      },
      store_order_rank: {
        data: [],
        waitTime: 200000,
        rowNum: 5
      },
      agent_info: {
        header: ["设备类型", "订单数", "订单金额"],
        data: []
      },
      option: {},
      info_data: [],
      refund_option: {},
      map_info: {},
      day_data: {},
      device_data: [],
      login_bgs: _pageBg.default,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      timing: null,
      withdraw_chart: null,
      refund_chart: null,
      map_chart: null,
      // * 定时函数
      drawTiming: null,
      isScale: true
    };
  },
  computed: {},
  created: function created() {
    this.getData();
    this.timeFn();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timing);
    clearInterval(this.drawTiming);
  },
  mounted: function mounted() {
    // this.withdraw_chart = echarts.init(this.$refs.withdraw_info);
  },
  methods: {
    //格式化时间
    timeFn: function timeFn() {
      var _this = this;
      this.timing = setInterval(function () {
        _this.dateDay = _this.formatTime(new Date(), "HH: mm: ss");
        _this.dateYear = _this.formatTime(new Date(), "yyyy-MM-dd");
        _this.dateWeek = _this.weekday[new Date().getDay()];
      }, 1000);
    },
    formatTime: function formatTime(time, fmt) {
      if (!time) return "";else {
        var date = new Date(time);
        var o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "H+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          S: date.getMilliseconds()
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
          }
        }
        return fmt;
      }
    },
    getData: function () {
      var _getData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, paymant_data, name, mapjson, cityCenter, arr, newData, mydata, map_option, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return this.$get("agentapi/dataV");
            case 1:
              data = _context.sent;
              paymant_data = [];
              data.day_profit_date.forEach(function (item, index) {
                paymant_data.push({
                  name: item,
                  value: data.day_profit_amount[index]
                });
              });
              this.paymant_data.data = paymant_data;
              this.paymant_data = _objectSpread({}, this.paymant_data);
              if (this.store_order_rank.data.length == 0) {
                this.store_order_rank.data = data.store_order_rank;
                this.store_order_rank = _objectSpread({}, this.store_order_rank);
              }
              if (this.agent_info.data.length == 0) {
                this.agent_info.data = data.agent_info;
                this.agent_info = _objectSpread({}, this.agent_info);
              }
              this.day_data = data.pie_chart;
              this.info_data = data.month_data;
              this.refund_option = {
                tooltip: {
                  trigger: "axis",
                  backgroundColor: "rgba(0,0,0,.6)",
                  borderColor: "rgba(147, 235, 248, .8)",
                  textStyle: {
                    color: "#FFF"
                  }
                },
                textStyle: {
                  fontSize: 14
                },
                legend: {
                  data: ["充电宝", "充电线", "充电桩"],
                  top: 10,
                  textStyle: {
                    color: "#FFF"
                  }
                },
                calculable: true,
                xAxis: {
                  type: "category",
                  data: data.columnars.date,
                  axisLabel: {
                    fontSize: 14
                  },
                  axisTick: {
                    lineStyle: {
                      color: "#FFF"
                    }
                  },
                  axisLine: {
                    lineStyle: {
                      color: "#FFF"
                    }
                  }
                },
                yAxis: {
                  name: "个数",
                  type: "value",
                  min: 0,
                  axisLabel: {
                    formatter: "{value} 个",
                    fontSize: 14
                  },
                  axisLine: {
                    lineStyle: {
                      color: "#FFF"
                    }
                  },
                  axisTick: {
                    lineStyle: {
                      color: "#FFF"
                    }
                  }
                },
                series: [{
                  name: "充电线",
                  data: data.columnars.cdx,
                  type: "bar",
                  markPoint: {
                    data: [{
                      type: "max",
                      name: "Max"
                    }, {
                      type: "min",
                      name: "Min"
                    }]
                  },
                  markLine: {
                    data: [{
                      type: "average",
                      name: "Avg"
                    }]
                  },
                  itemStyle: {
                    color: "#B6A2DE"
                  }
                }, {
                  name: "充电宝",
                  data: data.columnars.cdb,
                  type: "bar",
                  markPoint: {
                    data: [{
                      type: "max",
                      name: "Max"
                    }, {
                      type: "min",
                      name: "Min"
                    }]
                  },
                  markLine: {
                    data: [{
                      type: "average",
                      name: "Avg"
                    }]
                  },
                  itemStyle: {
                    color: "#2EC7C9"
                  }
                }, {
                  name: "充电桩",
                  data: data.columnars.cdz,
                  type: "bar",
                  markPoint: {
                    data: [{
                      type: "max",
                      name: "Max"
                    }, {
                      type: "min",
                      name: "Min"
                    }]
                  },
                  markLine: {
                    data: [{
                      type: "average",
                      name: "Avg"
                    }]
                  },
                  itemStyle: {
                    color: "#FFB99B"
                  }
                }]
              };
              this.device_data = data.all_device_data;
              this.device_data.map(function (item) {
                item.config = {
                  number: [Number(item.value)],
                  toFixed: 0,
                  style: {
                    fontSize: 30,
                    fill: "#3de7c9"
                  }
                };
              });

              // this.withdraw_chart.setOption(this.option, true);
              this.refund_chart = echarts.init(this.$refs.refund_info);
              this.refund_chart.setOption(this.refund_option, true);
              name = "china";
              mapjson = echarts.getMap(name);
              if (mapjson) {
                mapjson = mapjson.geoJson;
              } else {
                mapjson = _china.default;
                echarts.registerMap(name, mapjson);
              }
              cityCenter = {};
              arr = mapjson.features; //根据geojson获取省份中心点
              arr.map(function (item) {
                cityCenter[item.properties.name] = item.properties.centroid || item.properties.center;
              });
              newData = [];
              mydata = data.city_data || [];
              mydata.map(function (item) {
                if (cityCenter[item.name]) {
                  newData.push({
                    name: item.name,
                    value: cityCenter[item.name].concat(item.value)
                  });
                }
              });
              map_option = this.getMapInfo(name, mydata, newData);
              this.map_chart = echarts.init(this.$refs.map_info);
              this.map_chart.setOption(map_option, true);
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.log("🚀 ~ getData ~ e:", _t);
            case 3:
              this.showLoading = false;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    getMapInfo: function getMapInfo(name, data, data2) {
      var top = 45;
      var zoom = 1.05;
      var option = {
        backgroundColor: "rgba(0,0,0,0)",
        tooltip: {
          show: false
        },
        legend: {
          show: false
        },
        visualMap: {
          left: 20,
          bottom: 20,
          pieces: [{
            gte: 1000,
            label: "1000个以上"
          },
          // 不指定 max，表示 max 为无限大（Infinity）。
          {
            gte: 600,
            lte: 999,
            label: "600-999个"
          }, {
            gte: 200,
            lte: 599,
            label: "200-599个"
          }, {
            gte: 50,
            lte: 199,
            label: "49-199个"
          }, {
            gte: 10,
            lte: 49,
            label: "10-49个"
          }, {
            lte: 9,
            label: "1-9个"
          } // 不指定 min，表示 min 为无限大（-Infinity）。
          ],
          inRange: {
            // 渐变颜色，从小到大
            color: ["#c3d7df", "#5cb3cc", "#8abcd1", "#66a9c9", "#2f90b9", "#1781b5"]
          },
          textStyle: {
            color: "#fff"
          }
        },
        geo: {
          map: name,
          roam: false,
          selectedMode: false,
          //是否允许选中多个区域
          zoom: zoom,
          top: top,
          // aspectScale: 0.78,
          show: false
        },
        series: [{
          name: "MAP",
          type: "map",
          map: name,
          // aspectScale: 0.78,
          data: data,
          // data: [1,100],
          selectedMode: false,
          //是否允许选中多个区域
          zoom: zoom,
          geoIndex: 1,
          top: top,
          tooltip: {
            show: true,
            formatter: function formatter(params) {
              if (params.data) {
                return params.name + "：" + params.data["value"];
              } else {
                return params.name;
              }
            },
            backgroundColor: "rgba(0,0,0,.6)",
            borderColor: "rgba(147, 235, 248, .8)",
            textStyle: {
              color: "#FFF"
            }
          },
          label: {
            show: false,
            color: "#000",
            // position: [-10, 0],
            formatter: function formatter(val) {
              // console.log(val)
              if (val.data !== undefined) {
                return val.name.slice(0, 2);
              } else {
                return "";
              }
            },
            rich: {}
          },
          emphasis: {
            label: {
              show: false
            },
            itemStyle: {
              areaColor: "#389BB7",
              borderWidth: 1
            }
          },
          itemStyle: {
            borderColor: "rgba(147, 235, 248, .8)",
            borderWidth: 1,
            areaColor: {
              type: "radial",
              x: 0.5,
              y: 0.5,
              r: 0.8,
              colorStops: [{
                offset: 0,
                color: "rgba(147, 235, 248, 0)" // 0% 处的颜色
              }, {
                offset: 1,
                color: "rgba(147, 235, 248, .2)" // 100% 处的颜色
              }],
              globalCoord: false // 缺为 false
            },
            shadowColor: "rgba(128, 217, 248, .3)",
            shadowOffsetX: -2,
            shadowOffsetY: 2,
            shadowBlur: 10
          }
        }, {
          data: data2,
          type: "effectScatter",
          coordinateSystem: "geo",
          symbolSize: function symbolSize(val) {
            return 4;
            // return val[2] / 50;
          },
          legendHoverLink: true,
          showEffectOn: "render",
          rippleEffect: {
            // period: 4,
            scale: 6,
            color: "rgba(255,255,255, 1)",
            brushType: "fill"
          },
          tooltip: {
            show: true,
            formatter: function formatter(params) {
              if (params.data) {
                return params.name + "：" + params.data["value"][2];
              } else {
                return params.name;
              }
            },
            backgroundColor: "rgba(0,0,0,.6)",
            borderColor: "rgba(147, 235, 248, .8)",
            textStyle: {
              color: "#FFF"
            }
          },
          label: {
            formatter: function formatter(param) {
              return param.name.slice(0, 2);
            },
            fontSize: 11,
            offset: [0, 2],
            position: "bottom",
            textBorderColor: "#fff",
            textShadowColor: "#000",
            textShadowBlur: 10,
            textBorderWidth: 0,
            color: "#FFF",
            show: true
          },
          // colorBy: "data",
          itemStyle: {
            color: "rgba(255,255,255,1)",
            borderColor: "rgba(2255,255,255,2)",
            borderWidth: 4,
            shadowColor: "#000",
            shadowBlur: 10
          }
        }]
      };
      return option;
    }
  }
};